import * as Tilegrid from 'ol/tilegrid'
import * as TileUrlFunction from 'ol/tileurlfunction'
import TileImage from 'ol/source/TileImage'

class fallbackXYZ extends TileImage {
// const fallbackXYZ = function (opt) {
  constructor (options = {}) {
    const projection = options.projection || 'EPSG:3857'

    const tileGrid = options.tileGrid || Tilegrid.createXYZ({
      extent: Tilegrid.extentFromProjection(projection),
      maxZoom: options.maxZoom,
      minZoom: options.minZoom,
      tileSize: options.tileSize,
    })

    // Fonction de création de l'url de la tuile de base
    const tileUrlFunction = options.tileUrlFunction ||
    TileUrlFunction.createFromTemplate(options.url)

    // Fonction de création de l'url de la tuile de fallback
    const tileFallbackUrlFunction = options.tileFallbackUrlFunction ||
    TileUrlFunction.createFromTemplate(options.fallback)

    // Fonction génère les deux url pour les passer à la tuile
    const mainTileUrlFunction = function (urlTileCoord, pixelRatio, projection) {
      return [
        tileUrlFunction(urlTileCoord, pixelRatio, projection),
        tileFallbackUrlFunction(urlTileCoord, pixelRatio, projection),
      ]
    }

    // Fonction de chargement de la tuile de base
    const tileLoadFunction = options.tileLoadFunction || fallbackXYZ.prototype.defaultTileLoadFunction

    // Fonction de chargement de la tuile de fallback
    const tileFallbackLoadFunction = options.tileFallbackLoadFunction || fallbackXYZ.prototype.defaultTileLoadFunction

    // Fonction qui charge l'image de la tuile ou le fallback si erreur
    const mainTileLoadFunction = function (imageTile, [url, fallback]) {
    // Charge l'image de base
      return tileLoadFunction(imageTile, url)
      // Si erreur, charge le fallback
        .catch(() => tileFallbackLoadFunction(imageTile, fallback))
    }

    super({
      attributions: options.attributions,
      cacheSize: options.cacheSize,
      crossOrigin: options.crossOrigin,
      projection,
      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
      tileGrid,
      tileLoadFunction: mainTileLoadFunction,
      tileUrlFunction: mainTileUrlFunction,
      fallback: options.fallback,
      wrapX: options.wrapX !== undefined ? options.wrapX : true,
      transition: options.transition,
    })
  }
}

fallbackXYZ.prototype.defaultTileLoadFunction = function (imageTile, src) {
  return new Promise((resolve, reject) => {
    const img = imageTile.getImage()

    // Sur un error sur l'image, on reject
    img.onerror = function () {
      img.onerror = undefined
      img.onabort = undefined
      img.onload = undefined
      reject(new Error('Impossible d\'obtenir l\'image'))
    }

    // Sur un abort sur l'image, on reject
    img.onabort = function () {
      img.onerror = undefined
      img.onabort = undefined
      img.onload = undefined
      reject(new Error('Annulation de l\'obtention de l\'image'))
    }

    // Sur un load sur l'image, on resolve
    img.onload = function () {
      img.onerror = undefined
      img.onabort = undefined
      img.onload = undefined
      resolve()
    }

    img.src = src
  })
}

export default fallbackXYZ
